import * as React from 'react';
import i18n from '../../../../i18n';

// Interface icons: one line style (24 grid, 2px round strokes) drawn with
// currentColor. Set the colour with the `color` prop (a CSS value, usually a
// theme token) or let it inherit. Illustrations and brand marks (logo,
// Google "G", avatar, candle) stay images in modules/icons.
const PATHS = {
  back: <path d="M19 12H5M11 6l-6 6 6 6"/>,
  menu: <path d="M4 7h16M4 12h16M4 17h16"/>,
  close: <path d="M6 6l12 12M18 6 6 18"/>,
  plus: <path d="M12 5v14M5 12h14"/>,
  chevron: <path d="M9 6l6 6-6 6"/>,
  login: <path d="M14 4h3a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-3M4 12h11M11 8l4 4-4 4"/>,
  logout: <path d="M10 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h3M9 12h11M16 8l4 4-4 4"/>,
  eye: <><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/></>,
  trash: <path d="M4 7h16M9.5 7V4.8a.8.8 0 0 1 .8-.8h3.4a.8.8 0 0 1 .8.8V7M6.5 7l.8 12.2A2 2 0 0 0 9.3 21h5.4a2 2 0 0 0 2-1.8L17.5 7M10 11v6M14 11v6"/>,
  check: <path d="M5 12.5l4.5 4.5L19 7.5"/>,
  pencil: <path d="M15.5 4.5l4 4L9 19H5v-4zM13.5 6.5l4 4"/>,
  expand: <path d="M14 4h6v6M10 20H4v-6M20 4l-6.5 6.5M4 20l6.5-6.5"/>,
  alert: <><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5"/><circle cx="12" cy="16.5" r=".6" fill="currentColor"/></>,
  mic: <><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21"/></>,
  mail: <><rect x="3" y="5.5" width="18" height="13" rx="3"/><path d="M4 7.5l8 6 8-6"/></>,
  cog: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"/></>,
  refresh: <path d="M20 11a8 8 0 1 0-2.3 5.7M20 5v6h-6"/>,
  swap: <path d="M7 7h12l-3-3M17 17H5l3 3"/>,
};

export default function UiIcon({name, size = 24, width, height, color, rtl = false, strokeWidth = 2, className, style, onClick}) {
  const flip = rtl && i18n.dir() === 'rtl';
  const s = {...(color ? {color} : {}), ...(flip ? {transform: 'scaleX(-1)'} : {}), ...(style || {})};
  return (
    <svg className={className} style={s} onClick={onClick}
         width={width || size} height={height || size} viewBox="0 0 24 24"
         fill="none" stroke="currentColor" strokeWidth={strokeWidth}
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {PATHS[name]}
    </svg>
  );
}
